module.exports = __webpack_public_path__ + "static/media/four_function.78b11f59.png";